import React from 'react'
import { useRouter } from 'next/router'

import useCurrentUser from '@hook/user/useCurrentUser'
import ROUTES from '@constant/Routes'

type withPreventedRouteOptions = {
  redirectURI?: string
}
const withPreventedRouteDefaultOptions: withPreventedRouteOptions = {
  redirectURI: ROUTES.Download,
}

function withPreventedRoute<T>(Component: React.FC<T>, options = withPreventedRouteDefaultOptions) {
  const { redirectURI } = { ...withPreventedRouteDefaultOptions, ...options }
  return (props: T) => {
    const router = useRouter()

    const origin = router.query?.origin as string

    const { currentUser } = useCurrentUser()

    const { isAuthenticated } = React.useMemo(() => {
      const _isAuthenticated = !(currentUser == null)
      return { isAuthenticated: _isAuthenticated }
    }, [currentUser])

    if (isAuthenticated && !origin && !router.query.redirectTo?.length) {
      router.replace(redirectURI)
      return null
    }

    return <Component {...props} />
  }
}

export default withPreventedRoute
